import { FC } from "react";

import { List } from "@jti/ui/components/List/List";

import { linksListInputs } from "./LinksList.builder";

export type LinksListBuilderProps = BuilderComponentProps<
  typeof linksListInputs
>;

export const LinksList: FC<LinksListBuilderProps> = ({
  listItems,
  title,
  style,
  listClickEvent,
  enableCookieSettings,
}) => {
  if (!listItems || listItems.length === 0) {
    return (
      <div>
        <p>Add links in the builder.io editor to display links</p>
      </div>
    );
  }
  return (
    <List
      style={style}
      listClickEvent={listClickEvent}
      listItems={listItems}
      enableCookieSettings={enableCookieSettings}
      title={title}
    />
  );
};
